module.exports = __webpack_public_path__ + "media/Urknall_Foetzelirege.8800daef.mp4";